import type { NonEventContentObjectDetail } from 'models';
import { Card, Empty, Skeleton } from 'ui';
import { ContentObjectRenderer } from '../content-object-renderer';

type P = {
  contentObject: NonEventContentObjectDetail | undefined;
  isLoading: boolean;
};

const ContentObjectDetail = ({ contentObject, isLoading }: P) => {
  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 12 }} />;
  }

  if (!contentObject) {
    return (
      <Card>
        <Empty description="This content is no longer available" />
      </Card>
    );
  }

  return (
    <Card marginBottom={false}>
      <ContentObjectRenderer forceCommentsOpen item={contentObject} view="other" />
    </Card>
  );
};

export default ContentObjectDetail;
